export const dashboardNavigationItemsData = [
  { title: "Program", href: "/dashboard" },
  { title: "Support", href: "/support" },
  { title: "Settings", href: "/account" },
];

export default dashboardNavigationItemsData;
